exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*\n * Copyright (c) 2016-present, Parse, LLC\n * All rights reserved.\n *\n * This source code is licensed under the license found in the LICENSE file in\n * the root directory of this source tree.\n */\n.slider__QPU {\n  overflow: hidden;\n  transition: all 0.5s cubic-bezier(1, 0, 0, 1); }\n\n.metrics__3Bi {\n  width: 100%;\n  display: inline-block; }\n", ""]);
// Exports
exports.locals = {
	"slider": "slider__QPU",
	"metrics": "metrics__3Bi"
};